/* ---------------------------------------

    -- 要素の表示、非表示を管理

--------------------------------------- */
export default class Contents{
    constructor(effect,pageID){
        this.$pointMark;
        this.$panel=[];
        this.$scale=[];
        this.$show=[];
        this.$showDelay=[];
        this.$circle=[];

        this.$scrollDown;
        this.$headerNavi;

        this.timer = {
            panel : [],
            scale : [],
            show : [],
            showDelay : [],
        }

        this.point = [];

        this.status = {
            current : 0,//表示中のセンテンス
            prevCurrent : 0,//表示中のセンテンス
            nextCurrent : 0,//表示中のセンテンス
            pagenavi:{
                current:0,
                prevCurrent:0,
                type:"out"
            },
            flg : false, // 一回チェックしたら次のポイントまでは処理しない
            color : "white", // fixed uiの色管理
            bgColor : "white", // bodyの色管理
            show : [],
            showDelay : [],
            iconType : "down",
            scDownType:"down"
        }

        this.effect = effect;
        this.pageID = pageID;
        this.scInc = 0;
        this.dir = "";

        if(this.pageID !== 'study' || this.pageID !== 'lineup') {
            TweenMax.set(document.getElementById("c-scroll"), {
                x: -100,
            });
        }

        this.lastPoint;


        this.docHeight;
        this.winHeight;
        this.pageBottom;
        this.$body = document.getElementById('l-scroll-body');
        this.$tabTrigger = document.querySelectorAll(".js__tab-trigger");
    }
    init(){

        this.$pointMark = document.querySelectorAll(".js__sc-point");

        this.$scrollDown = document.getElementById("c-scroll");
        this.$headerNavi = document.getElementById("l-header__navi");
        this.$headerBtn = document.getElementById("l-header-btn");
        // this.$panel = document.getElementsByClassName("js__sc-show");

        for(let i in this.$pointMark){
            if(this.$pointMark[i].nodeType!=1) break; // dom要素以外は処理止める
            this.status.show[i] = false;
            this.$panel[i] = [];
            this.$scale[i]=[];
            this.$show[i]=[];
            this.$showDelay[i]=[];
            this.$circle[i]=[];

            let _panelNo = 0;
            let _scaleNo = 0;
            let _showNo = 0;
            let _showDelayNo = 0;
            let _circleNo = 0;


            let _$t = this.$pointMark[i].querySelectorAll(".js__sc-show");
            for(let j in _$t){
                if(_$t[j].nodeType!=1) break; // dom要素以外は処理止める
                if(_$t[j].getAttribute('class').indexOf('js__tsc-image-mask') != -1){
                    this.$panel[i][_panelNo] = this.$pointMark[i].querySelectorAll(".js__tsc-image-mask")[_panelNo];
                    _panelNo += 1;
                }else if(_$t[j].getAttribute('class').indexOf('js__tsc-scale') != -1){
                    this.$scale[i][_scaleNo] = this.$pointMark[i].querySelectorAll(".js__tsc-scale")[_scaleNo];
                    _scaleNo += 1;
                }else if(_$t[j].getAttribute('class').indexOf('js__tsc-show') != -1){
                    this.$show[i][_showNo] = this.$pointMark[i].querySelectorAll(".js__tsc-show")[_showNo];
                    _showNo += 1;
                }else if(_$t[j].getAttribute('class').indexOf('js__tsc-delay-show') != -1){
                    this.$showDelay[i][_showDelayNo] = this.$pointMark[i].querySelectorAll(".js__tsc-delay-show")[_showDelayNo];
                    _showDelayNo += 1;
                }else if(_$t[j].getAttribute('class').indexOf('js__tsc-circle') != -1){
                    this.$circle[i][_circleNo] = this.$pointMark[i].querySelectorAll(".js__tsc-circle")[_circleNo];
                    _circleNo += 1;
                }
            }

        }

        this.effect.panel(document.querySelectorAll(".js__tsc-image-mask"),"set");
        this.effect.scale(document.querySelectorAll(".js__tsc-scale"),"set");
        this.effect.show(document.querySelectorAll(".js__tsc-show"),"set");
        this.effect.showDelay(document.querySelectorAll(".js__tsc-delay-show"),"set");

        this.lastPoint = this.$pointMark.length-1;

        this.pageBottomCalc();

        if(this.$tabTrigger.length !== 0){
            for(let i in this.$tabTrigger){
                if(this.$tabTrigger[i].nodeType!==1) break;
                this.$tabTrigger[i].addEventListener("click",(e)=>{
                    this.resize();
                });
            }
        }
        window.addEventListener("orientationchange",(e)=>{
            this.resize();
        });
    }
    update(inc,dir,mouse){

        this.scInc = inc;
        this.dir = dir;
        this.minPageHeight = this.winHeight * 1.5 >= this.docHeight;

        if (this.$pointMark.length <= 0) return;

        for(let i in this.point){
            // if(this.point[i].start<inc&&dir=="next"||this.point[i].end>=inc&&dir=="prev"){
            if(this.point[i].start<inc&&dir=="next"||this.point[i].end>=inc&&dir=="prev"){
                if(this.status.show[i]) continue;
                this.status.show[i] = true;

                this.timer.panel[i] = setTimeout(()=>{
                    if(this.$panel[i]) this.effect.panel(this.$panel[i],"show");
                    if(this.$scale[i]) this.effect.scale(this.$scale[i],"show");
                },5e2);

                this.timer.show[i] = setTimeout(()=>{
                    if(this.$show[i]) this.effect.show(this.$show[i],"show");
                    if(this.$circle[i]) this.effect.circle(this.$circle[i],"show");
                },2e2);

                this.timer.showDelay[i] = setTimeout(()=>{
                    if(this.$showDelay[i]) this.effect.showDelay(this.$showDelay[i],"show");
                },4e2);


            }
            //kvとそれ以外でマウスポインタ切り替え
        }
        if(!this.point[0]) return;
        if(this.point[0].start<=inc&&this.point[0].end>=inc){
            if(this.pageID === 'top' && mouse){
                mouse.modeChange("full","scroll");
            }else if(this.pageID !== 'top' && this.pageID !== 'newpackage'){
                this.$headerNavi.classList.add('is-white');
                if(this.$headerBtn) this.$headerBtn.classList.add('is-white');
                TweenMax.set([this.$headerNavi.querySelectorAll(".jp"),this.$headerNavi.querySelectorAll(".en")],{
                    color : "#fff",
                });
            }
            if(this.minPageHeight) this.hideScrollDown();
        }else{
            if(this.pageID === 'top' && mouse){
                mouse.modeChange("small","scroll");
            }else if(this.pageID !== 'top' && this.pageID !== 'newpackage'){
                this.$headerNavi.classList.remove('is-white');
                if(this.$headerBtn) this.$headerBtn.classList.remove('is-white');
                TweenMax.set([this.$headerNavi.querySelectorAll(".jp"),this.$headerNavi.querySelectorAll(".en")],{
                    color : "#6b685e",
                });
            }
            if(this.minPageHeight){
                this.hideScrollDown();
            }else if(this.$scrollDown) {
                if(inc > 10){
                    this.scrollDownChange("hide");
                    this.pageBottomCalc();
                    if (this.pageBottom - 200 <= document.documentElement.scrollTop) {
                        this.scrollDownChange("top");
                    }else{
                        this.scrollDownChange("down");
                    }
                }
            }

        }

    }
    resize (winH) {

        for(let i in this.$pointMark){
            if(this.$pointMark[i].nodeType!=1) break; // dom要素以外は処理止める

            let _rect =  this.$pointMark[i].getBoundingClientRect();

            this.point[i] = {
                base : _rect.top + this.scInc,
                start: Math.max(_rect.top + this.scInc - window.innerHeight*0.5,0),
                end: _rect.top + this.scInc + this.$pointMark[i].clientHeight,
            }


            // let $p = this.$prarax[i],
            //     rect =  $p.getBoundingClientRect();
            // this.paraPoint[i] = {
            //     // base  : deviceSize=="pc"?rect.top : rect.top + this.scInc,
            //     base  : rect.top + this.scInc,
            //     start : deviceSize=="pc"?Math.max(0,rect.top + this.scInc - winH*1.5) : rect.top + this.scInc - winH*1.5,
            //     end   : deviceSize=="pc"?rect.top + this.scInc + winH : rect.top + this.scInc + winH*1.5,
            // }

        }

        this.pageBottomCalc();
    }
    scrollDownChange(type){

        if(this.status.scDownType == type) return;
        this.status.scDownType = type;
        TweenMax.to(this.$scrollDown,0.4,{
            x : -100,
            onComplete:()=>{

                if(this.status.scDownType=="top"){

                    this.$scrollDown.classList.add("is-pagetop");
                    this.$scrollDown.querySelectorAll(".en")[0].textContent = "Page top";
                    TweenMax.to(this.$scrollDown,0.4,{
                        x : 0,
                    })

                }else if(this.status.scDownType=="down"){

                    this.$scrollDown.classList.remove("is-pagetop");
                    this.$scrollDown.querySelectorAll(".en")[0].textContent = "Scroll"
                    if(this.pageID !== 'study' || this.pageID !== 'lineup'){
                        TweenMax.to(this.$scrollDown,0.4,{
                            x : 0,
                        })
                    }

                }

            }
        })
    }
    pageBottomCalc () {
        this.docHeight = this.$body.clientHeight;
        this.winHeight = window.innerHeight;
        this.pageBottom = this.docHeight - this.winHeight;
    }
    hideScrollDown () {
        if (this.status.scDownType == "top" || this.status.scDownType == "down") {
            this.scrollDownChange("hide");
        }
    }
}
